<template>
  <div class="detail-wrap">
    <el-form ref="formData" :model="formData">
      <div class="d-header clearfix">
        <div class="fl">
          <i class="el-icon-info" />
          {{ dataId ? '查看' : '新增' }}远程标准
        </div>
        <div class="fr">
          <el-button type="primary" class="button-sty" icon="el-icon-check" @click="saveData">保存</el-button>
        </div>
      </div>
      <div>
        <!-- 工单信息 -->
        <div class="d-cont edit-mce-box">
          <div class="d-item">
            <div class="title first">
              <!-- <b>主信息</b> -->
            </div>
            <table class="table-detail">
              <tbody>
                <tr>
                  <th>
                    <em class="f-red">*</em>
                    名称
                  </th>
                  <td>
                    <el-input type="text" autocomplete="off" v-model="formData.areaName" clearable />
                  </td>
                  <th>
                    区号
                  </th>
                  <td>
                    <el-input type="text" autocomplete="off" v-model="formData.areaCode" clearable />
                  </td>
                  <th>
                    <em class="f-red">*</em>
                    地区层级
                  </th>
                  <td>
                    <el-select v-model="formData.areaLevel">
                      <el-option label="国家" :value="0" />
                      <el-option label="省" :value="1" />
                      <el-option label="地级市" :value="2" />
                      <el-option label="区县" :value="3" />
                      <el-option label="街道" :value="4" />
                    </el-select>
                  </td>
                  <th>
                    <em class="f-red">*</em>
                    区域结算等级
                  </th>
                  <td>
                    <el-form-item prop="settleLevel" :rules="[{ required: true, trigger: 'blur' }]">
                      <el-select v-model="formData.settleLevel">
                        <el-option label="默认" :value="0" />
                        <el-option label="一级" :value="1" />
                        <el-option label="二级" :value="2" />
                        <el-option label="三级" :value="3" />
                        <el-option label="四级" :value="4" />
                      </el-select>
                    </el-form-item>
                  </td>
                </tr>
                <tr>
                  <th>
                    <em class="f-red">*</em>
                    启用
                  </th>
                  <td>
                    <el-select v-model="formData.usable">
                      <el-option label="否" :value="0" />
                      <el-option label="是" :value="1" />
                    </el-select>
                  </td>
                  <th>
                    开启派工到人
                  </th>
                  <td>
                    <el-select v-model="formData.openAutoAssign">
                      <el-option label="否" :value="0" />
                      <el-option label="是" :value="1" />
                    </el-select>
                  </td>
                  <th>
                    外部对接代码1
                  </th>
                  <td>
                    <el-input type="number" autocomplete="off" v-model="formData.code1" clearable />
                  </td>
                  <th>
                    外部对接代码2
                  </th>
                  <td>
                    <el-input type="number" autocomplete="off" v-model="formData.code2" clearable />
                  </td>
                </tr>
                <tr>
                  <th>
                    固定远程费(元)
                  </th>
                  <td>
                    <!-- <el-form-item prop="lockDistanceFee" :rules="[{ min: 0, trigger: 'blur' }]"> -->
                      <el-input type="number" autocomplete="off" v-model="formData.lockDistanceFee" clearable />
                    <!-- </el-form-item> -->
                  </td>
                  <th>
                    远程费基数(km)
                  </th>
                  <td>
                    <!-- <el-form-item prop="distanceBase" :rules="[{ min: 0, trigger: 'blur' }]"> -->
                      <el-input type="number" autocomplete="off" v-model="formData.distanceBase" clearable />
                    <!-- </el-form-item> -->
                  </td>
                  <th>
                    远程费率(元/km)
                  </th>
                  <td>
                    <!-- <el-form-item prop="distanceFee" :rules="[{ min: 0, trigger: 'blur' }]"> -->
                      <el-input type="number" autocomplete="off" v-model="formData.distanceFee" clearable />
                    <!-- </el-form-item> -->
                  </td>
                  <th>
                    封顶远程费
                  </th>
                  <td>
                    <!-- <el-form-item prop="topDistanceFee" :rules="[{ min: 0, trigger: 'blur' }]"> -->
                      <el-input type="number" autocomplete="off" v-model="formData.topDistanceFee" clearable />
                    <!-- </el-form-item> -->
                  </td>
                </tr>
                <tr>
                  <th>
                    远程点经度
                  </th>
                  <td><el-input type="number" autocomplete="off" v-model="formData.longitude" disabled clearable /></td>
                  <th>
                    远程点纬度
                  </th>
                  <td><el-input type="number" autocomplete="off" v-model="formData.latitude" disabled clearable /></td>
                  <th>
                    远程点
                  </th>
                  <td colspan="2"><el-input autocomplete="off" v-model="formData.distanceStartAddress"   :clearable="true"
                                            @clear="() => {formData.distanceStartAddress = '';
                                              formData.latitude = 0.0000000000000000;
                                              formData.longitude = 0.0000000000000000;
                                            }" /></td>
                  <td>   <el-button type="primary" class="button-sty"
                                    @click="doMapInterFace">经纬度测算
                  </el-button></td>
                </tr>
                <tr>
                  <th>创建人</th>
                  <td>{{ formData.createBy }}</td>
                  <th>创建时间</th>
                  <td>{{ formData.createDate }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </el-form>
  </div>
</template>
<script>
import request from "@/router/axios";
import api from "@/api/projectApi";
export default {
  name: 'edit',
  props: {
    _dataId: [String, Number]
  },
  components: {
  },
  data() {
    return {
      lan: 'zh_CN',
      isEdit: false,
      tabIndex: 'first',
      dataId: '',
      // 基本信息
      formData: {
        distanceStartAddress:null,
        latitude:null,
        longitude:null,
        status: 0,
        tenantAttachmentDTOs: []
      },
    };
  },
  computed: {
  },
  created() {
    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
  },
  mounted() {
    this.getData();
    console.log(this._dataId, "_dataId的值");
  },
  methods: {
    getData() {
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        request({
          url: '/basic/basArea/getById',
          method: 'post',
          data: {
            id: this.dataId
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          console.log(response.data.data);
          this.formData = response.data.data || {};
        })
      } else {
        // this.enabled = true;
      }
    },
    doMapInterFace(){
      this.$mask.open()
      this.$http({
        url: api.basArea.getPoint,
        method: 'post',
        data: {
          startAddress:this.formData.distanceStartAddress
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response =>{
        let i = {};
        i = response.data.data;
        this.formData.longitude =i.lng;
        this.formData.latitude =i.lat;
        this.$mask.close()
      }).catch(() => {
        this.$mask.close()
        this.$message.error(response.msg);
      })
      this.$mask.close()
    },
    saveData() {
      this.$refs.formData.validate(valid => {
        if (!valid) {
          this.$message.error("请输入必填项");
          return;
        }
        this.$baseConfirm('您确定要保存吗？').then(() => {
          this.$mask.open()

          var url = (this.isEdit ? `/basic/basArea/update` : `/basic/basArea/add`);
          this.$http({
            url: url,
            method: `post`,
            data: this.formData,
            isLoading: true,
          }).then(res => {

              console.log("return success", res)
              this.$message({
                message: res.data.content,
                type: 'success',
              });
              this.$emit('goBackIndex')
              this.$mask.close()


            }).catch(() => {
                this.$message.error("保存失败！");
                this.$mask.close()
              });

        });
      });
    },
  },
};

</script>
<style lang="scss" scoped></style>
